<script lang="ts">
	import { fade } from 'svelte/transition';

	let {
		text = '',
		visible = false,
		x = 0,
		y = 0
	}: {
		text?: string;
		visible?: boolean;
		x?: number;
		y?: number;
	} = $props();
</script>

{#if visible}
	<div
		transition:fade={{ duration: 100 }}
		class="tooltip"
		style="left: {x}px; top: {y}px; transform: translateX(-50%);"
		aria-live="polite"
	>
		{text}
	</div>
{/if}

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;
	.tooltip {
		position: fixed;
		background: var(--surface-1);
		color: var(--text-primary);
		border: 1px solid var(--border-subtle);
		padding: 4px 8px;
		border-radius: 0.5rem;
		font-size: 0.75rem;
		pointer-events: none;
		z-index: 1000;
		white-space: nowrap;
	}
</style>
